import "./Technology.css";
import Footer from "./Footer";
import solimg8 from "../assets/Tech-Digital1.jpg";
import solimg9 from "../assets/Tech-Digital2.png";


export default function TechDigital() {
    return (
        <section id="tech-digi">
            {/* TOP SECTION */}
            <div className="technology-wrapper-a">
                {/* LEFT CONTENT */}
                <div className="technology-text-a">
                    <h3>Digital</h3>
                    <h3>
                        Transforming manufacturing through intelligent digital solutions.
                    </h3>

                    <p>
                        At Sundaram-Clayton, digitisation is not a side project – it is the backbone of how we run our plants. We use modern IT–OT integration, private 5G–ready networks and Industry 4.0 platforms to improve quality, productivity and operational efficiency, so that customers see fewer surprises and more predictable performance.
                    </p>
                </div>
            </div>
            <div className="tech-img-grid">
                <img src={solimg8} alt="solutions" />
                <img src={solimg9} alt="solutions" />
            </div>

            <div className="tech-wrapper-a">
                {/* CARD 1 */}
                <div className="tech-card">
                    <div className="tech-header">
                        State-of-the-art digital backbone
                    </div>

                    <div className="tech-body">
                        <ul>
                            <li>
                                Dedicated data center with high-availability architecture, built on secure, high-speed connectivity and private 5G–ready infrastructure.
                            </li>
                            <li>Hardened cybersecurity and role-based access, ensuring production, quality and traceability data remain protected and audit-ready.</li>
                            <li>Integration of MES, QMS and ERP so that information flows seamlessly from order to dispatch.</li>
                        </ul>
                    </div>
                </div>

                {/* CARD 2 */}
                <div className="tech-card">
                    <div className="tech-header">
                        Smart intralogistics and monitoring
                    </div>

                    <div className="tech-body">
                        <ul>
                            <li>
                                AMR–ASRS–based intralogistics for automated movement and storage of castings and components, reducing manual handling, lead time and errors.
                            </li>
                            <li>Autonomous monitoring robots (AMR) and surveillance systems for unmanned patrols, safety checks and environment monitoring in critical areas.</li>
                            <li>BMS and LMS (Building and Light Management Systems) to supervise utilities, energy and line status from a single command view.</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="tech-wrapper-a">
                <div className="tech-card">
                    <div className="tech-header">
                        Real-time data and IoT on the shop floor
                    </div>

                    <div className="tech-body">
                        <div className="tech-body">
                            <ul>
                                <li>
                                    IoT sensors and edge gateways capturing process parameters, machine status, energy and environment data in real time.

                                </li>
                                <li>Live dashboards for OEE, quality losses, downtime and WIP, available to production and quality teams for faster decisions.
                                </li>
                                <li>SPC and condition monitoring integrated into the line, enabling proactive control instead of reactive firefighting.
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="tech-card">
                    <div className="tech-header">
                        Digital workflows for simpler, faster operations
                    </div>

                    <div className="tech-body">
                        <ul>
                            <li>
                                Digital work instructions, checklists and approvals for production, quality and maintenance activities, reducing paper and manual errors.
                            </li>
                            <li>e-Logs and e-Permits for traceable shift handovers, maintenance and safety activities.</li>
                            <li>Automated alerts and escalation workflows for deviations in quality, delivery or safety metrics.</li>
                        </ul>
                        <p>Whether finishing a structural EV component or a complex powertrain housing, our machining lines ensure <span className="blue">repeatability, tight tolerances, and consistent surface finish at scale.</span></p>
                    </div>
                </div>


            </div>

            <p style={{ textAlign: "center", margin: "30px 100px 60px 100px" }}>For customers and partners, this means a factory where data, machines and people are tightly connected – enabling faster response, higher consistency and stronger confidence in SCL as a long-term supplier for critical programmes.</p>
            <Footer />
        </section>
    );
}
